import moment from 'moment'
import { defaultListener } from "../helper"

export default {
  state: {
    bookingDialog: false,
    bookingDialogData: null,
    dayListener: null
  },
  getters: {
    getBookingDialog(state) {
      return state.bookingDialog
    },
    getBookingDialogData(state) {
      return state.bookingDialogData
    }
  },
  actions: {
    initDayBookingListener({ getters, state }, data){
      const { callback = () => {}, date } = data

      const sessionTenant = getters.getSessionTenant

      if (state.dayListener) {
        state.dayListener()
      }

      // Limit 1 as to not refresh multiple times
      state.dayListener =this.$firebase.firestore()
        .collection('tenants')
        .doc(sessionTenant)
        .collection('bookings')
        .where('date', '==', date)
        .limit(1)
        .orderBy('createdAt', 'desc')
        .onSnapshot(snap => {
            callback()
            snap.docChanges().forEach(change => {
              if (change.type === 'added') {
                const { id } = change.doc
                const booking = { id, ...change.doc.data() }

                callback(booking)
              }
            })
        }, e => {
            console.log(e)
          }
        )
    },
    getCustomerBookings({}, data) {
      const { id, pagination, expand } = data

      const payload = {
        params: { ...pagination, expand }
      }
      return this.$api.get(`/api/customer/${id}/bookings`, payload)
    },
    cancelBooking({}, data) {
      const { id, cancelReason } = data

      const payload = { cancelReason }

      return this.$api.post(`/api/booking/${id}/cancel`, payload)
    },
    createBooking({}, data) {
      return this.$api.post(`/api/booking`, data)
    },
    setBookingDialog({ dispatch, commit  }, val) {
      commit('SET_BOOKING_DIALOG', val)
    },
    openBookingDialog({ commit }, data) {
      commit('SET_BOOKING_DIALOG', true)
      commit('SET_BOOKING_DIALOG_DATA', data)
    },
    closeBookingDialog({ commit }) {
      commit('SET_BOOKING_DIALOG', false)
      commit('SET_BOOKING_DIALOG_DATA', null)
    }
  },
  mutations: {
    SET_BOOKING_DIALOG(state, val) {
      state.bookingDialog = !!val
    },
    SET_BOOKING_DIALOG_DATA(state, data) {
      state.bookingDialogData = data
    }
  }
}

